var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.002,
    height: 60.001,
    viewBox: "0 0 60.002 60.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M-20385,13662h-.234a26.361,26.361,0,0,0,3.227-.234v-19.157h6.629l1.057-8.592h-7.691v-5.923c.006-2.51.7-4.181,4.068-4.181h4.346v-7.686a56.365,56.365,0,0,0-6.328-.338c-6.512,0-10.555,4.351-10.555,11.354v6.769h-6.912v8.592h6.912v18.9a30.034,30.034,0,0,1-17.486-10.205,29.806,29.806,0,0,1-5.158-8.848A29.8,29.8,0,0,1-20415,13632a29.813,29.813,0,0,1,2.359-11.678,29.879,29.879,0,0,1,6.428-9.537,29.937,29.937,0,0,1,9.535-6.431A29.809,29.809,0,0,1-20385,13602a29.812,29.812,0,0,1,11.678,2.357,29.908,29.908,0,0,1,9.537,6.431,29.873,29.873,0,0,1,6.43,9.537A29.813,29.813,0,0,1-20355,13632a29.8,29.8,0,0,1-2.359,11.675,29.89,29.89,0,0,1-6.43,9.536,29.9,29.9,0,0,1-9.537,6.43A29.812,29.812,0,0,1-20385,13662Zm-.3,0h-.193a26.237,26.237,0,0,1-4.984-.477v-.024a30.042,30.042,0,0,0,5.178.5Z",
    transform: "translate(20415 -13601.999)",
    fill: "#1877f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLarge);
export default __webpack_public_path__ + "static/media/facebook-large.37770c04.svg";
export { ForwardRef as ReactComponent };